module.exports = __webpack_public_path__ + "static/media/Webdesign-Roar-2.ae6b7bbf.jpg";